import { NETWORK_STATUS_CONSTANTS } from '@/constants/networkStatus';

function getPing(server) {
    return new Promise(resolve => {
        const ts = +new Date;
        const image = new Image();

        image.onload = image.onerror = image.onabort = function(event) {
            const currentTS = +new Date;
            const totalTs = event?.type === 'load' ? (currentTS - ts) / 1000 : '-';

            resolve(totalTs);
        }
        image.src = server.url + '?' + Math.random();
    });
}

export default async function testNetwork(data) {
    if (data.servers.length === 0) return '';

    const result = {
        pushd: [data.pushdStatus]
    };

    for (const server of data.servers) {
        const serverFullName = `${server.serverType} (${server.url})`;
        result[serverFullName] = [];
        for (let i = 0; i < NETWORK_STATUS_CONSTANTS.PING_TRY_COUNT; i++) {
            const ping = await getPing(server);
            result[serverFullName].push(ping);
        }
    }

    return JSON.stringify(result);
}
